<div class="h-full flex flex-col bg-gray-50 w-full mx-auto font-prompt relative pb-30 overflow-auto">
  <!-- 1. Header ไล่ระดับสีพรีเมียมโค้งมน -->
  <div
    class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pb-24 pt-8 px-6 rounded-b-[2.5rem] relative z-10 text-white text-left select-none shadow-md">
    <!-- ปุ่มย้อนกลับ -->
    <div class="flex items-center justify-between mb-6">
      <button (click)="goback()"
        class="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 active:scale-90 transition-all outline-none">
        <img src="icons/arrow_back_white.svg" />
      </button>
      <span
        class="text-[10px] font-bold tracking-wider text-amber-400 bg-amber-500/10 px-3 py-1 rounded-full uppercase">
        {{ currentLang === "TH" ? "ข้อมูลทะเบียนรถ" : "Vehicle Setting" }}
      </span>
    </div>

    <!-- ข้อมูลต้อนรับส่วนตัว -->
    <div class="space-y-1">
      <h1 class="text-lg font-bold leading-tight">
        {{ currentLang === "TH" ? "สะดวกยิ่งขึ้นด้วย" : "Make it easier with" }}
      </h1>
      <p class="text-sm text-amber-400 font-bold">
        {{ currentLang === "TH" ? "ระบบจดจำป้ายทะเบียนอัจฉริยะ" : "Smart License Plate Recognition" }}
      </p>
    </div>
  </div>

  <!-- 2. แผ่นฟอร์มกรอกข้อมูลทับซ้อนส่วนหัว -->
  <div class="flex-grow px-4 relative z-20 -mt-12 select-none">
    <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-5">

      <!-- หมายเลขทะเบียนรถ -->
      <div>
        <label class="block font-bold text-sm text-gray-700 mb-1">
          {{ currentLang === "TH" ? "หมายเลขป้ายทะเบียน" : "License Plate Number" }}
          <span class="text-red-500 font-bold">*</span>
        </label>
        <span class="text-[10px] text-gray-400 font-medium block mb-2 leading-tight">
          {{ currentLang === "TH"
          ? "กรุณากรอกข้อมูลให้ตรงกับป้ายทะเบียนรถจริงเพื่อการตรวจสอบที่ถูกต้อง"
          : "Please fill in plate number exactly to ensure recognition accuracy" }}
        </span>
        <input type="text" [(ngModel)]="license" (ngModelChange)="validateLicense()"
          placeholder="{{ currentLang === 'TH' ? 'ตัวอย่าง: กข1234' : 'e.g. AB1234' }}"
          class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold" />
        <!-- ข้อความแจ้งเตือนรูปแบบทะเบียนผิดพลาด -->
        <p *ngIf="licenseError && license.trim()" class="text-[9px] font-bold text-red-500 mt-1 leading-none">
          {{ licenseError }}
        </p>
      </div>

      <!-- เลือกจังหวัด ( Custom autocomplete select dropdown ) -->
      <div class="relative">
        <label class="block font-bold text-sm text-gray-700 mb-1.5">
          {{ currentLang === "TH" ? "จังหวัดของป้ายทะเบียน" : "Plate Province" }}
          <span class="text-red-500 font-bold">*</span>
        </label>
        <div class="relative">
          <input type="text" [(ngModel)]="provinceSearchText" (focus)="openProvinceDropdown()"
            (blur)="closeProvinceDropdown()"
            placeholder="{{ currentLang === 'TH' ? 'ค้นหาจังหวัด...' : 'Search province...' }}"
            class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold cursor-pointer" />
          <div class="absolute right-3.5 top-1/2 -translate-y-1/2 pointer-events-none transition dulation-300"
            [class.rotate-180]="activeProvinceDropdown">
            <img src="icons/expand_more_slate_dark.svg" />
          </div>
        </div>

        <!-- Dropdown Options List -->
        <div *ngIf="activeProvinceDropdown" (mousedown)="$event.preventDefault()"
          class="absolute z-50 left-0 right-0 mt-1 max-h-40 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg scroll-smooth py-1">
          <div *ngFor="let p of filteredProvinceOptions" (click)="selectProvinceOption(p)"
            class="px-4 py-2.5 text-sm text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
            {{ p.label }}
          </div>
          <div *ngIf="filteredProvinceOptions.length === 0" class="px-4 py-2.5 text-sm text-gray-400 text-center">
            {{ currentLang === 'TH' ? 'ไม่พบข้อมูลจังหวัด' : 'No provinces found' }}
          </div>
        </div>
      </div>

      <!-- ประเภทยานพาหนะ -->
      <div>
        <label class="block font-bold text-sm text-gray-700 mb-2">
          {{ currentLang === "TH" ? "ประเภทยานพาหนะ" : "Vehicle Type" }}
          <span class="text-red-500 font-bold">*</span>
        </label>
        <div class="grid grid-cols-2 gap-2">
          <button *ngFor="let option of CarOptions" (click)="handleCarChange(option.value)"
            class="py-2.5 rounded-xl text-sm font-bold transition-all border outline-none active:scale-95 duration-200"
            [ngClass]="{
              'bg-amber-400 border-amber-400 text-white shadow-md': selectedCar === option.value,
              'bg-gray-50/50 border-gray-100 text-gray-500 hover:bg-gray-50 hover:text-gray-700': selectedCar !== option.value
            }">
            {{ option.label }}
          </button>
        </div>
      </div>

      <!-- ปุ่มดำเนินการหลัก -->
      <div class="pt-4 space-y-2.5">
        <button (click)="save()"
          class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-sm font-bold rounded-xl py-3 shadow-md transition-all duration-200 active:scale-95 outline-none">
          {{ currentLang === "TH"
          ? (disabled ? "บันทึกข้อมูลรถ" : "บันทึกการแก้ไข")
          : (disabled ? "Save Vehicle" : "Save Changes") }}
        </button>

        <!-- ปุ่มกดข้ามสำหรับผู้ใช้งานใหม่ (ถ้าต้องการ) -->
        <button *ngIf="!userStatus" (click)="clickSkips()"
          class="w-full bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-bold rounded-xl py-3 transition-all duration-200 active:scale-95 outline-none">
          {{ currentLang === "TH" ? "ข้ามขั้นตอนนี้" : "Skip this step" }}
        </button>
      </div>
    </div>
  </div>

  <!-- 3. แท็บความคืบหน้าลอยด้านล่างสุด ( mockup progress indicator ) -->
  <div *ngIf="stateProgress > 0"
    class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-6 py-4 flex items-center justify-between z-20">
    <div class="flex items-center gap-1">
      <span class="text-[10px] font-bold text-gray-400">{{ currentLang === "TH" ? "ขั้นตอน:" : "Step:" }}</span>
      <span class="text-sm font-bold text-amber-500">{{ stateProgress + 1 }} / 3</span>
    </div>
    <!-- เม็ดกลมแสดงขีดความคืบหน้าขั้นตอน -->
    <div class="flex gap-1.5">
      <div class="w-8 h-1.5 rounded-full transition-all duration-300" [class.bg-amber-400]="stateProgress >= 0"
        [class.bg-gray-200]="stateProgress < 0"></div>
      <div class="w-8 h-1.5 rounded-full transition-all duration-300" [class.bg-amber-400]="stateProgress >= 1"
        [class.bg-gray-200]="stateProgress < 1"></div>
      <div class="w-8 h-1.5 rounded-full transition-all duration-300" [class.bg-amber-400]="stateProgress >= 2"
        [class.bg-gray-200]="stateProgress < 2"></div>
    </div>
  </div>
</div>

<!------------------------------------------ MODALS & TOASTS ------------------------------------>

<!-- ยืนยันการบันทึกข้อมูล -->
<app-pss-warn *ngIf="showModal" [detail]="currentLang === 'TH'
      ? (disabled ? 'คุณต้องการบันทึกข้อมูลรถยนต์ใหม่ ใช่ไหม?' : 'คุณต้องการบันทึกการแก้ไขข้อมูลรถ ใช่ไหม?')
      : (disabled ? 'Are you sure you want to save this new vehicle information?' : 'Are you sure you want to edit this vehicle information?')
  " [language]="currentLang" [isButtonConfirm]="true" (submit)="sendApi()" (close)="closeModal()"></app-pss-warn>

<!-- แจ้งเตือนกรอกรายละเอียดป้าย -->
<app-pss-warn *ngIf="!userStatus && isWarningModal" [detail]="currentLang === 'TH'
      ? 'กรุณากรอกหมายเลขทะเบียนและจังหวัดเพื่อให้กล้องลานจอดสามารถอ่านป้ายได้ถูกต้อง'
      : 'Please enter the plate number and province to ensure correct camera recognition'
  " [language]="currentLang" [isButtonClose]="true" (close)="closeWarnModal()"></app-pss-warn>

<!-- หน้ากากโหลดดิ้ง -->
<app-pss-loading *ngIf="isLoading || isSaveLoading"></app-pss-loading>